module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-aai-student-box-items-icon-prev-292e6fbd5540d98300d98ebb2783d1f9.svg";